<template>
  <div counseling>
    <div class="wrapper">
      <h2>GYNPAD COUNSELING</h2>
      <h3>문의사항은 확인 후 <br class="hidden-lg-up">
        순차적으로 답변 드리겠습니다 <br><br class="hidden-lg-up">
        기타 제품 관련 질병에 대한 문의사항은 <br class="hidden-lg-up">
        다소 지연 될 수 있습니다
      </h3>
      <div class="menu">
        <a>faq</a>
        <a @click="formData = {}; question = true">secret 질문하기</a>
        <a @click="reqData = {}; answer1 = true">secret 답변확인</a>
      </div>
      <section class="faq">
        <ul>
          <li v-for="item in listData" :key="item.SQ">
            <a @click="toggle">
              <div class="q"><span>Q</span><i v-html="contParse(item.Q)"></i></div>
              <div class="a"><span>A</span><i v-html="contParse(item.A)"></i></div>
            </a>
          </li>
        </ul>
      </section>
    </div>
    <transition name="fade">
      <popup v-if="question">
        <div class="panel question">
          <div class="close" @click="question = false"></div>
          <p class="t1">
            - 제품관련 문의사항은 24시간 이내에 답변해 드립니다 <br>
            - 기타 제품 관련 질병에 대한 문의 사항은 7일 이내에 답변해 드립니다
          </p>
          <form>
          <table>
            <tbody>
            <tr>
              <th>제목</th>
              <td><input type="text" v-model="formData.TITLE"></td>
            </tr>
            <tr>
              <th>내용</th>
              <td><textarea v-model="formData.CONT"></textarea></td>
            </tr>
            <tr>
              <th>별명 입력</th>
              <td><input v-model="formData.ID" type="text" class="id"><a class="btn-check" @click="checkId">중복 확인</a></td>
            </tr>
            <tr>
              <th>답변확인 <br class="hidden-lg-up">비밀번호</th>
              <td><input type="password" v-model="formData.PWD"></td>
            </tr>
            </tbody>
          </table>
          </form>
          <p class="t2">
            별명, 비밀번호는 <b>답변 확인 용도</b>입니다. <br>
            분실 시, <br class="hidden-lg-up">찾기 어려우므로 <b>신중하게 입력</b>해주시기 바랍니다.
          </p>
          <div class="tc"><a @click="add" class="btn black">질문 등록하기</a></div>
        </div>
      </popup>
    </transition>
    <transition name="fade">
      <popup v-if="answer1">
        <div class="panel answer">
          <div class="close" @click="answer1 = false"></div>
          <div class="t1">
            질문에 답변을 찾고 계신가요?
            <p>질문 당시 입력했던 별명과 비밀번호를 정확히 입력해 주세요.</p>
          </div>
          <form>
          <table>
            <tbody>
            <tr>
              <th>별명 입력</th>
              <td><input type="text" class="id" v-model="reqData.ID"></td>
            </tr>
            <tr>
              <th>답변확인 <br class="hidden-lg-up">비밀번호</th>
              <td><input type="password" v-model="reqData.PWD"></td>
            </tr>
            </tbody>
          </table>
          </form>
          <div class="tc"><a @click="find" class="btn black">답변 확인하기</a></div>
        </div>
      </popup>
    </transition>
    <transition name="fade">
      <popup v-if="answer2">
        <div class="panel answer">
          <div class="close" @click="answer2 = false"></div>
          <div class="t1">궁금한 점이 있으시면, <br class="hidden-md-down">언제든 다시 질문해 주세요!</div>
          <p class="q"><b>Q</b><i v-html="answerData.TITLE"></i></p>
          <p class="a"><b>A</b>
            <i v-if="answerData.ANS" v-html="contParse(answerData.ANS)"></i>
            <i v-else>아직 답변이 등록되지 않았습니다</i>
          </p>
          <div class="tc"><a @click="answer2 = false" class="btn black">확 인</a></div>
        </div>
      </popup>
    </transition>
  </div>
</template>

<style lang="less" scoped>
  @import "../less/gynpad";
  @import "../less/asset";
  [counseling] { .rel; background:#fcfcfd url("@{common}/counceling-bg.s.png") no-repeat; background-size:cover; }
  .wrapper { padding:0 25px; }
  h2 { .rp-t(35); .fs(2.91rem); .oswald; color:#f85c70; .tc; }
  h3 { .rm-t(10); .fsl(1.25rem,1.5); color:#000; .tc; }
  .menu { margin-top:30px; .tc;
    a { .ib; .ir; .vat; .wh(75px, 100px); background-repeat:no-repeat; background-size:contain; margin:0 5px;
      &:nth-child(1) { background-image:url("@{common}/btn-faq.png"); }
      &:nth-child(2) { background-image:url("@{common}/btn-secret-1.png"); }
      &:nth-child(3) { background-image:url("@{common}/btn-secret-2.png"); }
    }
  }
  .faq { .border-v(#323841,2px); margin:20px 0 50px;
    li { .border-b(#d6d5d8);
      a { .block; }
      .q { padding:18px 15px 18px 33px; text-indent: -18px; span { .ib; .fs(15px); color:#f85c70; margin-right:8px; text-indent: 0; } }
      .a { display:none; padding:18px 15px 18px 58px; text-indent: -18px;  span { .ib; .fs(15px); margin-right:8px; text-indent: 0; } }
      a.on {
        .q { background:#f85c70; color:#fff; span { color:#fff; }  }
        .a { .block; background:#fce4e6; }
      }
    }
  }

  [popup] {
    .panel { margin:60px 25px 0; padding:65px 25px 25px; background:#fff; .border-box; .border(@c-pink, 2px); .rel;
      &:after { content:''; .block; .lt(15px,-35px); .wh(85px,94px); background-repeat: no-repeat; background-size:cover; }
      .close { .rt-r(18,18); .rwh(18); .contain('@{common}/close_pink.svg'); }
      .btn.black { margin-top:15px; width:150px; }
      table { width:100%; margin-top:20px; .border(#e1e1e1);
        th { .tl; background:#f6f6f6; padding:10px; width:80px; .border-box; .border-v(#e1e1e1); }
        td { padding:10px; .border-v(#e1e1e1); .rel;
          input { border:0; -webkit-appearance: none; .fsl(12,20px); height:20px; width:100%; }
          textarea { height:100px; width:100%; font-size: inherit }
          .id { width:auto; }
          .btn-check { .rt; .wh(60px,100%); background:#696b70; display:flex; align-items:center; justify-content:center; color:#fff; }
        }
      }
      &.question {
        &:after { background-image:url("@{common}/pop-question-label.png"); }
        p.t2 { margin:15px 0; .tc; }
      }
      &.answer {
        &:after { background-image:url("@{common}/pop-answer1-label.png"); }
        .t1 { .fs(1.25rem);
          p { .fsl(1rem,22px); color:@c-pink; padding-left:25px; height:20px; background:url("@{common}/ico-warning.png") no-repeat; background-size:contain; }
        }
        .q { .rel; .fs(1.25rem); padding:15px 15px 15px 30px; color:@c-pink;
          b { .ib; .lt(5px,10px); .fs(1.5rem); }
        }
        .a { .rel; .fs(1.25rem); padding:30px 15px 30px 40px; background:#fce4e6;
          b { .ib; .lt(20px,25px); .fs(1.5rem); }
        }
      }
    }
  }

  @media (min-width: @screen-lg-min) {
    [counseling] { background:#fcfcfd url("@{common}/counceling-bg.l.png") no-repeat; background-size:auto; }
    .wrapper { max-width:1080px; margin:auto; padding-bottom: 100px; }
    h2 { padding-top:180px; .fs(100px); }
    h3 { margin-top:20px; .fs(26px); }
    .menu { margin-top:90px;
      a { .wh(245px, 269px); margin:0 20px;
        &:nth-child(1) { margin-top:-40px; background-image:url("@{common}/btn-faq.png"); }
        &:nth-child(2) { background-image:url("@{common}/btn-secret-1.png"); &:hover { background-image:url("@{common}/btn-secret-1-on.png"); }}
        &:nth-child(3) { background-image:url("@{common}/btn-secret-2.png"); &:hover { background-image:url("@{common}/btn-secret-2-on.png"); }}
      }
    }
    .faq { margin:100px 0 150px;
      li {
        .q { .rel; padding:30px 130px 30px 64px; .fs(18px); text-indent: -34px;
          span { .fs(20px); margin-right:20px; }
          &:after { content:''; .block; .rt(58px,50%); margin-top:-4px; .wh(17px,9px); background:url("@{common}/faq-arr-down.png"); }
        }
        .a { padding:30px 50px 30px 112px; .fs(18px); text-indent: -32px; span { .fs(20px); margin-right:20px; }}
        a.on {
          .q { background:#f85c70; color:#fff; span { color:#fff; } &:after { background-image:url("@{common}/faq-arr-up.png"); } }
          .a { .block; background:#fce4e6; }
        }
      }
    }

    [popup] {
      .panel { width: 820px; .m-hc; margin-top:100px; .border(@c-pink, 4px); padding:160px 70px 50px;
        &:after { .lt(70px,-47px); .wh(171px,188px); }
        .close { .wh(66px,108px); .contain('@{common}/close_pink_pc.png'); .rt(-70px,-4px); cursor:pointer; }
        .btn.black { margin-top:25px; width:200px; }
        table { margin-top:0; .fs(18px);
          th { padding:20px; width:180px; }
          td { padding:20px;
            input { .fsl(18px,30px); height:30px; }
            textarea { height:180px; }
            .id { width:330px; }
            .btn-check { width:130px; }
          }
        }
        &.question {
          p.t1 { .lt(260px,40px); }
          p.t2 { margin:25px 0; .fs(20px); }
        }
        &.answer {
          .t1 { .lt(260px,40px); }
          .q { .fs(22px); padding:20px 20px 20px 70px;
            b { .lt(30px,7px); .fs(36px); }
          }
          .a { .fs(16px); padding:50px 20px 50px 70px;
            b { .lt(40px,46px); .fs(20px); }
          }
        }
      }
    }
  }

</style>

<script>
import axios from 'axios';
import qs from 'qs';
import handler from '../util/ErrorHandler';
import { contParse, toggleClass } from '../util';
import Popup from '../components/Pop.vue';

export default {
  name: 'Counseling',
  components: { Popup },
  data() {
    return {
      formData: {},
      reqData: {},
      listData: null,
      question: false,
      answer1: false,
      answer2: false,
      checkedId: null,
      answerData: null,
    };
  },
  methods: {
    toggle(e) {
      toggleClass(e.currentTarget, 'on');
    },
    contParse(org) {
      return contParse(org);
    },
    checkId() {
      if (!this.formData.ID || this.formData.TITLE.length < 4) {
        alert('별명을 4글자이상 입력해주세요');
        return;
      }
      axios.post('/api/qna/check', qs.stringify(this.formData))
        .then(({ data }) => {
          if (data.count === 0) {
            alert('사용 가능합니다');
            this.checkedId = this.formData.ID;
          } else {
            alert('다른 별명을 입력해주세요');
          }
        })
        .catch(handler);
    },
    add() {
      if (this.formData.ID !== this.checkedId) {
        alert('별명 중복확인을 해주세요');
        return;
      }
      if (!this.formData.TITLE || this.formData.TITLE.length < 10) {
        alert('제목을 10글자이상 입력해주세요');
        return;
      }
      if (!this.formData.CONT || this.formData.CONT.length < 10) {
        alert('내용을 10글자이상 입력해주세요');
        return;
      }
      if (!this.formData.PWD || this.formData.PWD.length < 4) {
        alert('비밀번호를 4글자이상 입력해주세요');
        return;
      }
      axios.post('/api/qna/add', qs.stringify(this.formData))
        .then(({ data }) => {
          if (data.count === 1) {
            alert('질문이 등록되었습니다');
            this.question = false;
          } else {
            alert('질문 등록을 실패했습니다');
          }
        })
        .catch(handler);
    },
    find() {
      if (!this.reqData.ID) {
        alert('별명을 입력해주세요');
        return;
      }
      if (!this.reqData.PWD) {
        alert('비밀번호를 입력해주세요');
        return;
      }
      axios.post('/api/qna/find', qs.stringify(this.reqData))
        .then(({ data }) => {
          if (data) {
            this.answerData = data;
            this.answer2 = true;
          } else {
            alert('일치하는 질문이 존재하지 않습니다');
          }
          this.answer1 = false;
        })
        .catch(handler);
    },
  },
  mounted() {
    axios.get('/api/faq/list')
      .then(({ data }) => {
        this.listData = data.list;
      })
      .catch(handler);
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Counseling.vue